export const BUTTON_VARIANT_M = 'm';
export const BUTTON_VARIANT_S = 's';
export const BUTTON_VARIANT_OUTLINE = 'outline';
export const BUTTON_VARIANT_CTA = 'cta';
export const BUTTON_VARIANT_FILTER = 'filter';
